import { SmartMTEditorPopup } from "./_editor_popup";
import { getBlobUrl, getImgBlob, setImgBlob, setIndexOnApply, setCurrentMode, getCurrentMimeType } from "./_utils";
import { showToastMessage } from "./_utils";


var $ = jQuery;

export const Resize = (attachment) => {
    $('#smart-mt-resize').on('click', function () {
        setCurrentMode('resize');

        // Ensure Cropper is destroyed before entering resize mode
        if (window.SmartMT.cropper) {
            window.SmartMT.cropper.destroy();
            window.SmartMT.cropper = null;
        }

        // Reset cropped dimensions
        window.SmartMT.croppedWidth = null;
        window.SmartMT.croppedHeight = null;

        let imgBlob = getImgBlob();
        let url = getBlobUrl(imgBlob) !== false ? getBlobUrl(imgBlob) : attachment.url;

        const resizeContent = `
            <div class="smart-mt-content smart-mt-content-resize">
                <div id="smartmt-preview-container">
                    <img id="smartmt-edit-image" src="${url}" alt="${attachment.name}" />
                </div>
                <div id="resize-dimensions-display">
                    <span id="current-dimensions">${attachment.width} * ${attachment.height}</span>
                    <span class="dashicons dashicons-arrow-right-alt"></span> 
                    <strong id="new-dimensions">${attachment.width} * ${attachment.height}</strong>
                </div>
            </div>`;

        const resizeSidebar = `
            <div id="resize-controls" class="sidebareffects">
                <div id="size-controls">
                    <label for="resizeWidth">Width</label>
                    <input type="number" id="resizeWidth" min="1" step="1" placeholder="Width">
                    
                    <label for="resizeHeight">Height</label>
                    <input type="number" id="resizeHeight" min="1" step="1" placeholder="Height">
                    
                    <div class="resize-aspect-ratio-container">
                        <label for="maintain-aspect-ratio">Maintain aspect ratio</label>
                        <input type="checkbox" id="maintain-aspect-ratio" checked>
                    </div>
                </div>
            </div>
                <div class="button-access">
                    <button class="button" id="resize-apply">
                        <span class="dashicons dashicons-saved"></span> Apply
                    </button>
                </div> `;

        SmartMTEditorPopup(resizeContent, resizeSidebar);

        initializeResizeFunctionality(attachment);

        function initializeResizeFunctionality(attachment) {
            const widthInput = document.getElementById('resizeWidth');
            const heightInput = document.getElementById('resizeHeight');
            const aspectRatioCheckbox = document.getElementById('maintain-aspect-ratio');
            const dimensionsDisplay = document.getElementById('current-dimensions');
            const newDimensionsDisplay = document.getElementById('new-dimensions');
            const imageElement = document.getElementById('smartmt-edit-image');

            // Try to get last applied size from the image blob history
            let imgBlob = getImgBlob();
            let lastAppliedSize = imgBlob ? window.SmartMT.lastResizeSize : null;

            // If we have a stored size, use that; otherwise, fall back to original
            let croppedWidth = lastAppliedSize ? lastAppliedSize.width : (window.SmartMT.croppedWidth || attachment.width);
            let croppedHeight = lastAppliedSize ? lastAppliedSize.height : (window.SmartMT.croppedHeight || attachment.height);

            // Handle cases where width/height becomes 0
            if (!croppedWidth || !croppedHeight) {
                croppedWidth = attachment.width;
                croppedHeight = attachment.height;
            }

            const naturalAspectRatio = croppedWidth / croppedHeight;
            dimensionsDisplay.innerHTML = `${croppedWidth} * ${croppedHeight}`;
            newDimensionsDisplay.innerHTML = '';

            resetResizeFields(croppedWidth, croppedHeight);

            let maintainAspectRatio = aspectRatioCheckbox.checked;

            aspectRatioCheckbox.addEventListener('change', function () {
                maintainAspectRatio = aspectRatioCheckbox.checked;
            });

            function updateNewDimensionsDisplay(newWidth, newHeight) {
                newDimensionsDisplay.innerHTML = `${newWidth} * ${newHeight}`;
            }

            widthInput.addEventListener('input', function () {
                const newWidth = parseInt(widthInput.value, 10);
                if (maintainAspectRatio && !isNaN(newWidth) && newWidth > 0) {
                    heightInput.value = Math.round(newWidth / naturalAspectRatio);
                }
                const newHeight = parseInt(heightInput.value, 10);
                if (!isNaN(newWidth) && !isNaN(newHeight)) {
                    updateNewDimensionsDisplay(newWidth, newHeight);
                }
            });

            heightInput.addEventListener('input', function () {
                const newHeight = parseInt(heightInput.value, 10);
                if (maintainAspectRatio && !isNaN(newHeight) && newHeight > 0) {
                    widthInput.value = Math.round(newHeight * naturalAspectRatio);
                }
                const newWidth = parseInt(widthInput.value, 10);
                if (!isNaN(newWidth) && !isNaN(newHeight)) {
                    updateNewDimensionsDisplay(newWidth, newHeight);
                }
            });

            // Save last applied size in a global variable
            window.SmartMT.lastResizeSize = { width: croppedWidth, height: croppedHeight };


            heightInput.addEventListener('input', function () {
                const newHeight = parseInt(heightInput.value, 10);
                if (maintainAspectRatio && !isNaN(newHeight) && newHeight > 0) {
                    widthInput.value = Math.round(newHeight * naturalAspectRatio);
                }
                const newWidth = parseInt(widthInput.value, 10);
                if (!isNaN(newWidth) && !isNaN(newHeight)) {
                    updateNewDimensionsDisplay(newWidth, newHeight);
                }
            });

            $(document).off('click', '#resize-apply').on('click', '#resize-apply', function () {
                let currentIndex = window.SmartMT.currentIndex;
                setIndexOnApply(+currentIndex);
                const newWidth = parseInt(widthInput.value, 10);
                const newHeight = parseInt(heightInput.value, 10);

                if (!isNaN(newWidth) && !isNaN(newHeight) && newWidth > 0 && newHeight > 0) {
                    const canvas = document.createElement('canvas');
                    const ctx = canvas.getContext('2d');

                    canvas.width = newWidth;
                    canvas.height = newHeight;

                    ctx.drawImage(imageElement, 0, 0, newWidth, newHeight);

                    canvas.toBlob((blob) => {
                        if (blob) {
                            setImgBlob(blob);

                            const updatedImageUrl = URL.createObjectURL(blob);
                            imageElement.src = updatedImageUrl;

                            resetResizeFields(newWidth, newHeight);
                            updateNewDimensionsDisplay(newWidth, newHeight);
                            showToastMessage("Successfully Applied", "success");

                            // ✅ Save last resized size globally for persistence
                            window.SmartMT.lastResizeSize = { width: newWidth, height: newHeight };
                        }
                    }, getCurrentMimeType());
                } else {
                    showToastMessage("Invalid dimensions. Please enter valid width and height.", "error");
                }
            });
        }

        function resetResizeFields(width, height) {
            const widthInput = document.getElementById('resizeWidth');
            const heightInput = document.getElementById('resizeHeight');

            widthInput.value = width;
            heightInput.value = height;
        }
    });
};
